"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorFactory = void 0;
var tslib_1 = require("tslib");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var common_1 = require("../_util/common");
var bulletChartColoring_1 = tslib_1.__importDefault(require("../bulletChart/bulletChartColoring"));
var measure_1 = require("../_chartColoring/measure");
var sdk_ui_vis_commons_1 = require("@gooddata/sdk-ui-vis-commons");
var heatmapColoring_1 = require("../heatmap/heatmapColoring");
var treemapColoring_1 = require("../treemap/treemapColoring");
var bubbleChartColoring_1 = require("../bubbleChart/bubbleChartColoring");
var scatterPlotColoring_1 = require("../scatterPlot/scatterPlotColoring");
var attributeChartSupportedTypes = [
    sdk_ui_1.VisualizationTypes.PIE,
    sdk_ui_1.VisualizationTypes.DONUT,
    sdk_ui_1.VisualizationTypes.FUNNEL,
    sdk_ui_1.VisualizationTypes.SCATTER,
    sdk_ui_1.VisualizationTypes.BUBBLE,
];
function isAttributeColorPalette(type, dv, stackByAttribute) {
    var attributeChartSupported = common_1.isOneOfTypes(type, attributeChartSupportedTypes);
    return stackByAttribute || (attributeChartSupported && dv.def().hasAttributes());
}
var ColorFactory = /** @class */ (function () {
    function ColorFactory() {
    }
    ColorFactory.getColorStrategy = function (colorPalette, colorMapping, 
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    viewByAttribute, 
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    stackByAttribute, dv, type, theme) {
        if (colorPalette === void 0) { colorPalette = sdk_ui_1.DefaultColorPalette; }
        if (common_1.isHeatmap(type)) {
            return new heatmapColoring_1.HeatmapColorStrategy(colorPalette, colorMapping, viewByAttribute, stackByAttribute, dv, theme);
        }
        if (common_1.isTreemap(type)) {
            return new treemapColoring_1.TreemapColorStrategy(colorPalette, colorMapping, viewByAttribute, stackByAttribute, dv, theme);
        }
        if (common_1.isScatterPlot(type)) {
            return new scatterPlotColoring_1.ScatterPlotColorStrategy(colorPalette, colorMapping, viewByAttribute, stackByAttribute, dv, theme);
        }
        if (common_1.isBubbleChart(type)) {
            return new bubbleChartColoring_1.BubbleChartColorStrategy(colorPalette, colorMapping, viewByAttribute, stackByAttribute, dv, theme);
        }
        if (common_1.isBulletChart(type)) {
            return new bulletChartColoring_1.default(colorPalette, colorMapping, viewByAttribute, stackByAttribute, dv, theme);
        }
        if (isAttributeColorPalette(type, dv, stackByAttribute)) {
            return new sdk_ui_vis_commons_1.AttributeColorStrategy(colorPalette, colorMapping, viewByAttribute, stackByAttribute, dv, theme);
        }
        return new measure_1.MeasureColorStrategy(colorPalette, colorMapping, viewByAttribute, stackByAttribute, dv, theme);
    };
    return ColorFactory;
}());
exports.ColorFactory = ColorFactory;
//# sourceMappingURL=colorFactory.js.map